import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { evaluateHideComponent } from "@Modules/eventPage/utils/render";
import { IContentHeader } from "./IContentHeader";
import styles from "./contentHeader.module.scss";
import commonStyles from "../commonStyles.module.scss";

const ContentHeader = ({
    EventMedia,

    showOn = "desktop",
    isMobile,
    title,
    shortDescription,
    showEventMedia,
    paymentPlanType,
}: IContentHeader.IProps) => {
    if (evaluateHideComponent({ showOn, isMobile })) return null;

    return (
        <div
            className={classNames(
                styles.header,
                isMobile
                    ? styles.isMobile
                    : commonStyles.detailsSectionsContainer
            )}
        >
            {showEventMedia && EventMedia ? <EventMedia /> : null}
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.shortDescriptionWrapper}>
                <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: shortDescription,
                    }}
                    className={styles.shortDescription}
                />
                {paymentPlanType && (
                    <>
                        {!isMobile && <> &nbsp;|&nbsp;</>}
                        <div className={styles.chipWrapper}>
                            <span className={styles.chipStyle}>
                                {paymentPlanType}
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ContentHeader;
